@for (item of listOnboardingFlow; track $index) { @if (item.id ===
getActualBalao() ) {
<ion-img
  class="ion-hide-md-up"
  [class]="item.class"
  (click)="tutorial(item)"
  [src]="item.pathImg"
  alt="balao_1"
></ion-img>
} }
